import { ThemeConfig } from 'antd';

export const THEME_LIGHT: ThemeConfig = {
	token: {
		colorText: "#1e1e1f",
		colorTextSecondary: "#4f5153",
		colorTextTertiary: "#828486",
		colorTextQuaternary: "#c1c1c3",
		colorBgMask: "#828486",
		colorBgSpotlight: "#28282a",
		colorBorder: "#e0e0e1",
		colorBorderSecondary: "#eff0f0",
		colorFill: "#d0d1d2",
		colorFillSecondary: "#e0e0e1",
		colorFillTertiary: "#eff0f0",
		colorFillQuaternary: "#eff0f0",
		colorFillAlter: "#eff0f0",
		colorSplit: "#eff0f0",
		sizeLG: 30,
		sizeMD: 24,
		sizeMS: 20,
		controlHeight: 44,
		controlHeightLG: 52,
		controlHeightSM: 36,
		controlHeightXS: 30,
		fontFamily: "Roboto",
		fontFamilyCode: "Roboto Mono",
	},
	components: {
		Layout: {
			bodyBg: '#fff',
			headerBg: '#fff',
		},
		Menu: {
			subMenuItemBg: "#eff0f0",
			darkSubMenuItemBg: "#0a0a0a",
			darkItemDisabledColor: "#828486",
			darkItemColor: "#828486",
			darkGroupTitleColor: "#636568",
			activeBarBorderWidth: 0,
			itemColor: '#4F5153',
			itemSelectedColor: '#1E1E1F',
			itemHoverColor: '#1677FF',
			itemHoverBg: '#E6F4FF',
			itemActiveBg: '#E6F4FF',
			itemSelectedBg: '#E6F4FF',
			itemHeight: 44,
			itemMarginInline: 0,
			itemMarginBlock: 4,
			iconMarginInlineEnd: 8,

		},
		Button: {
			paddingInlineSM: 12,
			paddingInlineLG: 16,
			paddingInline: 16
		},
		FloatButton: {
			sizePopupArrow: 16,
			paddingXS: 8,
			marginXXS: 4,
			marginXS: 8,
			lineWidthFocus: 4,
			controlPaddingHorizontal: 12,
			controlItemBgActiveHover: "#bae0ff",
			controlItemBgActive: "#e6f4ff",
			controlHeight: 44,
			borderRadiusXS: 4,
			colorTextDisabled: "#c1c1c3",
			colorTextDescription: "#828486",
			colorPrimaryBorder: "#91caff",
			colorError: "#ff4d4f"
		},
		Radio: {
			buttonBg: "#1677ff",
			buttonColor: "#ffffff"
		},
		InputNumber: {
			colorTextQuaternary: "#c1c1c3",
			colorFillSecondary: "#e0e0e1",
			colorFillTertiary: "#eff0f0",
			colorWarningBg: "#fffbe6",
			colorWarningBgHover: "#fff1b8",
			colorErrorBg: "#fff2f0",
			colorErrorBgHover: "#fff1f0",
			filledHandleBg: "#ffffff",
			colorErrorText: "#ff4d4f",
			colorWarningText: "#faad14"
		},
		Select: {
			showArrowPaddingInlineEnd: 18
		},
		Table: {
			cellPaddingInlineMD: 16,
			cellPaddingBlockMD: 16,
		}

	}
};

export const THEME_DARK: ThemeConfig = {
	token: {
		colorText: "#d0d1d2",
		colorTextSecondary: "#828486",
		colorTextTertiary: "#4f5153",
		colorTextQuaternary: "#28282a",
		colorBgMask: "#828486",
		colorBgSpotlight: "#4f5153",
		colorBorder: "#28282a",
		colorBorderSecondary: "#0a0a0a",
		colorFill: "#28282a",
		colorFillSecondary: "#1e1e1f",
		colorFillTertiary: "#141415",
		colorFillQuaternary: "#0a0a0a",
		colorSplit: "#0a0a0a",
		sizeLG: 30,
		sizeMD: 24,
		sizeMS: 20,
		controlHeight: 44,
		controlHeightLG: 52,
		controlHeightSM: 36,
		controlHeightXS: 30,
		fontFamily: "Roboto",
		fontFamilyCode: "Roboto Mono",
		colorFillAlter: "#0a0a0a",
	},
	components: {
		Menu: {
			subMenuItemBg: "#0a0a0a",
			darkSubMenuItemBg: "#eff0f0",
			darkItemDisabledColor: "#4f5153",
			darkItemColor: "#4f5153",
			darkGroupTitleColor: "#636568"
		},
		Button: {
			paddingInlineSM: 12,
			paddingInlineLG: 16,
			paddingInline: 16
		},
		FloatButton: {
			sizePopupArrow: 16,
			paddingXS: 8,
			marginXXS: 4,
			marginXS: 8,
			lineWidthFocus: 4,
			controlPaddingHorizontal: 12,
			controlItemBgActiveHover: "#112545",
			controlItemBgActive: "#111a2c",
			controlHeight: 44,
			borderRadiusXS: 4,
			colorTextDisabled: "#28282a",
			colorTextDescription: "#4f5153",
			colorPrimaryBorder: "#15325b",
			colorError: "#dc4446"
		},
		Radio: {
			buttonBg: "#1668dc",
			buttonColor: "#ffffff"
		},
		InputNumber: {
			colorTextQuaternary: "#28282a",
			colorFillSecondary: "#1e1e1f",
			colorFillTertiary: "#141415",
			colorWarningBg: "#2b2111",
			colorWarningBgHover: "#443111",
			colorErrorBg: "#2c1618",
			colorErrorBgHover: "#451d1f",
			filledHandleBg: "#0a0a0a",
			colorErrorText: "#dc4446",
			colorWarningText: "#d89614"
		},
		Select: {
			showArrowPaddingInlineEnd: 18
		}
	}
};
